import BaseType from "../BaseType";
import Guid from "../Guid";

export default class SiteStatus extends BaseType {
  SiteId: string = Guid.Empty;
  IsActive: boolean = false;
  CreatedOn: string = "";
}
